import { useRef } from "react";

import { TenantDto } from "@/core/api/generated/v1";

import { useCurrentTenant } from "./useCurrentTenant";

export interface UseMyTenantAffiliationHookResult {
  tenantId: Nil<string>;
  currentTenantId: Nil<string>;
  isMyTenant: boolean;
  isOtherTenant: boolean;
}

/** Checks if current tenant is the same as provided tenant. */
export function useMyTenantAffiliation(props: {
  tenantId: Nil<string>;
  currentTenant?: Nil<TenantDto>;
  currentTenantId?: Nil<string>;
}): UseMyTenantAffiliationHookResult {
  const currentTenant = useCurrentTenant();

  const currentTenantIdComputed =
    props.currentTenant?.id || props.currentTenantId || currentTenant?.id;
  const isTenantIdsNonEmpty = !!currentTenantIdComputed && !!props.tenantId;
  const isMyTenant = isTenantIdsNonEmpty && currentTenantIdComputed === props.tenantId;
  const isOtherTenant = isTenantIdsNonEmpty && currentTenantIdComputed !== props.tenantId;

  const resultRef = useRef<UseMyTenantAffiliationHookResult>({
    tenantId: props.tenantId,
    currentTenantId: currentTenantIdComputed,
    isMyTenant,
    isOtherTenant,
  });

  resultRef.current.tenantId = props.tenantId;
  resultRef.current.currentTenantId = currentTenantIdComputed;
  resultRef.current.isMyTenant = isMyTenant;
  resultRef.current.isOtherTenant = isOtherTenant;

  return resultRef.current;
}
